import { useEffect, useRef } from 'react'

export default function useValueChangeEffect<T>(value: T, onChange: (value: T) => void) {
    const key = JSON.stringify(value ?? null)
    const latestValue = useRef(value)
    latestValue.current = value
    const latestOnChange = useRef(onChange)
    latestOnChange.current = onChange
    const appliedKey = useRef(key)

    useEffect(() => {
        if (appliedKey.current === key) return
        appliedKey.current = key
        latestOnChange.current(latestValue.current)
    }, [key])
}
